/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.6028 10.7255h-5.25l-.1458.0086c-.6217.0736-1.1042.6123-1.1042 1.2659 0 .7039.5596 1.2745 1.25 1.2745h7.75v-12l-.0084-.1486C13.0222.492 12.4938 0 11.8528 0l-.1458.0086c-.6217.0736-1.1042.6123-1.1042 1.2659v9.451ZM23.8528 12c0-4.9584-3.0355-9.3513-7.5657-11.1537-.5773-.2297-1.2315.052-1.4612.6293-.2297.5774.0521 1.2315.6294 1.4613 3.681 1.4645 6.1475 5.034 6.1475 9.0631 0 5.3848-4.3652 9.75-9.75 9.75-3.7292 0-7.0799-2.1117-8.7219-5.3868-.2784-.5554-.9545-.7799-1.5099-.5014-.5554.2784-.78.9544-.5014 1.5099C3.1395 21.4007 7.264 24 11.8528 24c6.6274 0 12-5.3726 12-12Z"
    clipRule="evenodd"
  />,
  'MenuLatency'
);
